import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import apiAuth from "../../helpers/ApiAuth";
import { reMapGetFacilitiesData } from "./normalizers";
import {
  GET_FACILITY,
  GET_FACILITY_SUCCESS,
  GET_FACILITY_ERROR,
  ADD_FACILITY,
  ADD_FACILITY_SUCCESS,
  ADD_FACILITY_ERROR,
  EDIT_FACILITY,
  EDIT_FACILITY_SUCCESS,
  EDIT_FACILITY_ERROR,
  DELETE_FACILITY,
  DELETE_FACILITY_SUCCESS,
  DELETE_FACILITY_ERROR,
  ADD_FLOOR,
  ADD_FLOOR_SUCCESS,
  ADD_FLOOR_ERROR,
  EDIT_FLOOR,
  EDIT_FLOOR_SUCCESS,
  EDIT_FLOOR_ERROR,
  DELETE_FLOOR,
  DELETE_FLOOR_SUCCESS,
  DELETE_FLOOR_ERROR,
  ADD_SECTOR,
  ADD_SECTOR_SUCCESS,
  ADD_SECTOR_ERROR,
  EDIT_SECTOR,
  EDIT_SECTOR_SUCCESS,
  EDIT_SECTOR_ERROR,
  DELETE_SECTOR,
  DELETE_SECTOR_SUCCESS,
  DELETE_SECTOR_ERROR,
  ADD_SHIFT,
  ADD_SHIFT_SUCCESS,
  ADD_SHIFT_ERROR,
  EDIT_SHIFT,
  EDIT_SHIFT_SUCCESS,
  EDIT_SHIFT_ERROR,
  DELETE_SHIFT,
  DELETE_SHIFT_SUCCESS,
  DELETE_SHIFT_ERROR,
  LOGOUT_USER,
  FACILITY_ACTION_ERROR,
  ADD_EMPLOYEE_POLICY,
  ADD_EMPLOYEE_POLICY_SUCCESS,
  ADD_EMPLOYEE_POLICY_ERROR,
  EDIT_EMPLOYEE_POLICY,
  EDIT_EMPLOYEE_POLICY_SUCCESS,
  EDIT_EMPLOYEE_POLICY_ERROR,
  DELETE_EMPLOYEE_POLICY,
  DELETE_EMPLOYEE_POLICY_SUCCESS,
  DELETE_EMPLOYEE_POLICY_ERROR,
  ADD_HOLIDAY,
  ADD_HOLIDAY_SUCCESS,
  ADD_HOLIDAY_ERROR,
  EDIT_HOLIDAY,
  EDIT_HOLIDAY_SUCCESS,
  EDIT_HOLIDAY_ERROR,
  DELETE_HOLIDAY,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_ERROR,
  ADD_REPORT_ALERT,
  ADD_REPORT_ALERT_SUCCESS,
  ADD_REPORT_ALERT_ERROR,
  EDIT_REPORT_ALERT,
  EDIT_REPORT_ALERT_SUCCESS,
  EDIT_REPORT_ALERT_ERROR,
  DELETE_REPORT_ALERT,
  DELETE_REPORT_ALERT_SUCCESS,
  DELETE_REPORT_ALERT_ERROR,
} from "../actions";

export function* watchActionError() {
  yield takeEvery(FACILITY_ACTION_ERROR, FacilityActionError);
}

function* FacilityActionError(message) {
  try {
    if (message.payload.response.status === 401) {
      yield put({ type: LOGOUT_USER });
    }

    yield put({
      type: message.payload.action,
      payload: message.payload.response,
    });
  } catch (error) {}
}

export function* watchGetFacility() {
  yield takeEvery(GET_FACILITY, getFacility);
}

const getFacilityDataAsync = async () =>
  await apiAuth
    .get("/api/company_all/")
    .then((facilities) => facilities.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* getFacility() {
  try {
    const facilities = yield call(getFacilityDataAsync);

    if (!facilities.message) {
      const payload = reMapGetFacilitiesData(facilities);
      yield put({ type: GET_FACILITY_SUCCESS, payload: payload });
    } else {
      facilities.message.action = GET_FACILITY_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: facilities.message });
    }
  } catch (error) {
    yield put({ type: GET_FACILITY_ERROR, payload: error });
  }
}

export function* watchAddFacility() {
  yield takeEvery(ADD_FACILITY, addFacility);
}

const addFacilityAsync = async (facility) =>
  await apiAuth
    .post("/api/facility/", facility)
    .then((facilities) => facilities.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* addFacility(facilityObj) {
  try {
    const facility = yield call(addFacilityAsync, facilityObj.payload);

    if (!facility.message) {
      yield put({ type: ADD_FACILITY_SUCCESS, payload: facility });
    } else {
      facility.message.action = ADD_FACILITY_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: facility.message });
    }
  } catch (error) {
    yield put({ type: ADD_FACILITY_ERROR, payload: error });
  }
}

export function* watchEditFacility() {
  yield takeEvery(EDIT_FACILITY, editFacility);
}

const editFacilityAsync = async (facility) =>
  await apiAuth
    .patch(`/api/facility/${facility.id}/`, facility)
    .then((facilities) => facilities.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* editFacility(facilityObj) {
  try {
    const facility = yield call(editFacilityAsync, facilityObj.payload);
    console.log(facility);
    if (!facility.message) {
      yield put({ type: EDIT_FACILITY_SUCCESS, payload: facility });
    } else {
      facility.message.action = EDIT_FACILITY_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: facility.message });
    }
  } catch (error) {
    yield put({ type: EDIT_FACILITY_ERROR, payload: error });
  }
}

export function* watchDeleteFacility() {
  yield takeEvery(DELETE_FACILITY, deleteFacility);
}

const deleteFacilityAsync = async (facility) =>
  await apiAuth
    .delete(`/api/facility/${facility.id}/`)
    .then((facility) => facility)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* deleteFacility(facilityObj) {
  try {
    const facility = yield call(deleteFacilityAsync, facilityObj.payload);

    if (!facility.message) {
      yield put({
        type: DELETE_FACILITY_SUCCESS,
        payload: facilityObj.payload.id,
      });
    } else {
      facility.message.action = DELETE_FACILITY_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: facility.message });
    }
  } catch (error) {
    yield put({ type: DELETE_FACILITY_ERROR, payload: error });
  }
}

export function* watchAddFloor() {
  yield takeEvery(ADD_FLOOR, addFloor);
}

const addFloorAsync = async (floor) =>
  await apiAuth
    .post("/api/floor/", floor)
    .then((floor) => floor.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* addFloor(floorObj) {
  try {
    const floor = yield call(addFloorAsync, floorObj.payload);

    if (!floor.message) {
      yield put({ type: ADD_FLOOR_SUCCESS, payload: floor });
    } else {
      floor.message.action = ADD_FLOOR_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: floor.message });
    }
  } catch (error) {
    yield put({ type: ADD_FLOOR_ERROR, payload: error });
  }
}

export function* watchEditFloor() {
  yield takeEvery(EDIT_FLOOR, editFloor);
}

const editFloorAsync = async (floor) =>
  await apiAuth
    .patch(`/api/floor/${floor.id}/`, floor)
    .then((floor) => floor.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* editFloor(floorObj) {
  try {
    const floor = yield call(editFloorAsync, floorObj.payload);

    if (!floor.message) {
      yield put({ type: EDIT_FLOOR_SUCCESS, payload: floor });
    } else {
      floor.message.action = EDIT_FLOOR_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: floor.message });
    }
  } catch (error) {
    yield put({ type: EDIT_FLOOR_ERROR, payload: error });
  }
}

export function* watchDeleteFloor() {
  yield takeEvery(DELETE_FLOOR, deleteFloor);
}

const deleteFloorAsync = async (floor) =>
  await apiAuth
    .delete(`/api/floor/${floor.id}/`)
    .then((floor) => floor)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* deleteFloor(floorObj) {
  try {
    const floor = yield call(deleteFloorAsync, floorObj.payload);

    if (!floor.message) {
      yield put({ type: DELETE_FLOOR_SUCCESS, payload: floorObj.payload.id });
    } else {
      floor.message.action = DELETE_FLOOR_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: floor.message });
    }
  } catch (error) {
    yield put({ type: DELETE_FLOOR_ERROR, payload: error });
  }
}

export function* watchAddSector() {
  yield takeEvery(ADD_SECTOR, addSector);
}

const addSectorAsync = async (sector) => {
  const formData = new FormData();
  if (sector.image) {
    formData.append("plan", sector.image);
  }

  formData.append("sector_name", sector.sector_name);
  formData.append("floor", sector.floor);
  formData.append("x1", sector.x1);
  formData.append("y1", sector.y1);

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return await apiAuth
    .post("/api/sector/", formData, config)
    .then((sector) => {
      return sector.data;
    })
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};
function* addSector(sectorObj) {
  try {
    const sector = yield call(addSectorAsync, sectorObj.payload);

    if (!sector.message) {
      sector.facility = sectorObj.payload.facility;

      yield put({ type: ADD_SECTOR_SUCCESS, payload: sector });
    } else {
      sector.message.action = ADD_SECTOR_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: sector.message });
    }
  } catch (error) {
    yield put({ type: ADD_SECTOR_ERROR, payload: error });
  }
}

export function* watchEditSector() {
  yield takeEvery(EDIT_SECTOR, editSector);
}

const editSectorAsync = async (sector) => {
  const formData = new FormData();
  if (sector.image) {
    formData.append("plan", sector.image);
  }
  formData.append("id", sector.id);
  formData.append("sector_name", sector.sector_name);
  formData.append("floor", sector.floor);
  formData.append("x1", sector.x1);
  formData.append("y1", sector.y1);

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  return await apiAuth
    .patch(`/api/sector/${sector.id}`, formData, config)
    .then((sector) => sector.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};

function* editSector(sectorObj) {
  try {
    const sector = yield call(editSectorAsync, sectorObj.payload);

    if (!sector.message) {
      sector.facility = sectorObj.payload.facility;
      yield put({ type: EDIT_SECTOR_SUCCESS, payload: sector });
    } else {
      sector.message.action = EDIT_SECTOR_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: sector.message });
    }
  } catch (error) {
    yield put({ type: EDIT_SECTOR_ERROR, payload: error });
  }
}

export function* watchDeleteSector() {
  yield takeEvery(DELETE_SECTOR, deleteSector);
}

const deleteSectorAsync = async (sector) =>
  await apiAuth
    .delete(`/api/sector/${sector.id}/`)
    .then((sector) => sector)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* deleteSector(sectorObj) {
  try {
    const sector = yield call(deleteSectorAsync, sectorObj.payload);

    if (!sector.message) {
      yield put({ type: DELETE_SECTOR_SUCCESS, payload: sectorObj.payload.id });
    } else {
      sector.message.action = DELETE_SECTOR_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: sector.message });
    }
  } catch (error) {
    yield put({ type: DELETE_SECTOR_ERROR, payload: error });
  }
}

//Manage Shifts
export function* watchAddShift() {
  yield takeEvery(ADD_SHIFT, addShift);
}

const addShiftAsync = async (shift) => {
  return await apiAuth
    .post("/api/shift/", shift)
    .then((shift) => {
      return shift.data;
    })
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};
function* addShift(shiftObj) {
  try {
    const shift = yield call(addShiftAsync, shiftObj.payload);

    if (!shift.message) {
      yield put({ type: ADD_SHIFT_SUCCESS, payload: shift });
    } else {
      shift.message.action = ADD_SHIFT_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: shift.message });
    }
  } catch (error) {
    yield put({ type: ADD_SHIFT_ERROR, payload: error });
  }
}

export function* watchEditShift() {
  yield takeEvery(EDIT_SHIFT, editShift);
}

const editShiftAsync = async (shift) => {
  return await apiAuth
    .patch(`/api/shift/${shift.id}`, shift)
    .then((shift) => shift.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};

function* editShift(shiftObj) {
  try {
    const shift = yield call(editShiftAsync, shiftObj.payload);

    if (!shift.message) {
      yield put({ type: EDIT_SHIFT_SUCCESS, payload: shift });
    } else {
      shift.message.action = EDIT_SHIFT_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: shift.message });
    }
  } catch (error) {
    yield put({ type: EDIT_SHIFT_ERROR, payload: error });
  }
}

export function* watchDeleteShift() {
  yield takeEvery(DELETE_SHIFT, deleteShift);
}

const deleteShiftAsync = async (shift) =>
  await apiAuth
    .delete(`/api/shift/${shift.id}/`)
    .then((shift) => shift)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* deleteShift(shiftObj) {
  try {
    const shift = yield call(deleteShiftAsync, shiftObj.payload);

    if (!shift.message) {
      yield put({ type: DELETE_SHIFT_SUCCESS, payload: shiftObj.payload.id });
    } else {
      shift.message.action = DELETE_SHIFT_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: shift.message });
    }
  } catch (error) {
    yield put({ type: DELETE_SHIFT_ERROR, payload: error });
  }
}

//Manage Employee Policy

export function* watchAddEmployeePolicy() {
  yield takeEvery(ADD_EMPLOYEE_POLICY, addEmployeePolicy);
}

const addEmployeePolicyAsync = async (employee_policy) => {
  return await apiAuth
    .post("/api/employee/policy/", employee_policy)
    .then((employee_policy) => {
      return employee_policy.data;
    })
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};
function* addEmployeePolicy(employee_policyObj) {
  try {
    const employee_policy = yield call(
      addEmployeePolicyAsync,
      employee_policyObj.payload
    );

    if (!employee_policy.message) {
      yield put({
        type: ADD_EMPLOYEE_POLICY_SUCCESS,
        payload: employee_policy,
      });
    } else {
      employee_policy.message.action = ADD_EMPLOYEE_POLICY_ERROR;
      yield put({
        type: FACILITY_ACTION_ERROR,
        payload: employee_policy.message,
      });
    }
  } catch (error) {
    yield put({ type: ADD_EMPLOYEE_POLICY_ERROR, payload: error });
  }
}

export function* watchEditEmployeePolicy() {
  yield takeEvery(EDIT_EMPLOYEE_POLICY, editEmployeePolicy);
}

const editEmployeePolicyAsync = async (employee_policy) => {
  return await apiAuth
    .patch(`/api/employee/policy/${employee_policy.id}/`, employee_policy)
    .then((employee_policy) => employee_policy.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};

function* editEmployeePolicy(employee_policyObj) {
  try {
    const employee_policy = yield call(
      editEmployeePolicyAsync,
      employee_policyObj.payload
    );

    if (!employee_policy.message) {
      yield put({
        type: EDIT_EMPLOYEE_POLICY_SUCCESS,
        payload: employee_policy,
      });
    } else {
      employee_policy.message.action = EDIT_EMPLOYEE_POLICY_ERROR;
      yield put({
        type: FACILITY_ACTION_ERROR,
        payload: employee_policy.message,
      });
    }
  } catch (error) {
    yield put({ type: EDIT_EMPLOYEE_POLICY_ERROR, payload: error });
  }
}

export function* watchDeleteEmployeePolicy() {
  yield takeEvery(DELETE_EMPLOYEE_POLICY, deleteEmployeePolicy);
}

const deleteEmployeePolicyAsync = async (employee_policy) =>
  await apiAuth
    .delete(`/api/employee/policy/${employee_policy.id}/`)
    .then((employee_policy) => employee_policy)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* deleteEmployeePolicy(employee_policyObj) {
  try {
    const employee_policy = yield call(
      deleteEmployeePolicyAsync,
      employee_policyObj.payload
    );

    if (!employee_policy.message) {
      yield put({
        type: DELETE_EMPLOYEE_POLICY_SUCCESS,
        payload: employee_policyObj.payload.id,
      });
    } else {
      employee_policy.message.action = DELETE_EMPLOYEE_POLICY_ERROR;
      yield put({
        type: FACILITY_ACTION_ERROR,
        payload: employee_policy.message,
      });
    }
  } catch (error) {
    yield put({ type: DELETE_EMPLOYEE_POLICY_ERROR, payload: error });
  }
}

//Manage Holidays
export function* watchAddHoliday() {
  yield takeEvery(ADD_HOLIDAY, addHoliday);
}

const addHolidayAsync = async (holiday) => {
  return await apiAuth
    .post("/api/employee/holiday/", holiday)
    .then((holiday) => {
      return holiday.data;
    })
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};
function* addHoliday(holidayObj) {
  try {
    const holiday = yield call(addHolidayAsync, holidayObj.payload);

    if (!holiday.message) {
      yield put({ type: ADD_HOLIDAY_SUCCESS, payload: holiday });
    } else {
      holiday.message.action = ADD_HOLIDAY_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: holiday.message });
    }
  } catch (error) {
    yield put({ type: ADD_HOLIDAY_ERROR, payload: error });
  }
}

export function* watchEditHoliday() {
  yield takeEvery(EDIT_HOLIDAY, editHoliday);
}

const editHolidayAsync = async (holiday) => {
  return await apiAuth
    .patch(`/api/employee/holiday/${holiday.id}/`, holiday)
    .then((holiday) => holiday.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};

function* editHoliday(holidayObj) {
  try {
    const holiday = yield call(editHolidayAsync, holidayObj.payload);

    if (!holiday.message) {
      yield put({ type: EDIT_HOLIDAY_SUCCESS, payload: holiday });
    } else {
      holiday.message.action = EDIT_HOLIDAY_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: holiday.message });
    }
  } catch (error) {
    yield put({ type: EDIT_HOLIDAY_ERROR, payload: error });
  }
}

export function* watchDeleteHoliday() {
  yield takeEvery(DELETE_HOLIDAY, deleteHoliday);
}

const deleteHolidayAsync = async (holiday) =>
  await apiAuth
    .delete(`/api/employee/holiday/${holiday.id}/`)
    .then((holiday) => holiday)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* deleteHoliday(holidayObj) {
  try {
    const holiday = yield call(deleteHolidayAsync, holidayObj.payload);

    if (!holiday.message) {
      yield put({
        type: DELETE_HOLIDAY_SUCCESS,
        payload: holidayObj.payload.id,
      });
    } else {
      holiday.message.action = DELETE_HOLIDAY_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: holiday.message });
    }
  } catch (error) {
    yield put({ type: DELETE_HOLIDAY_ERROR, payload: error });
  }
}

//Manage Report Alerts
export function* watchAddReportAlert() {
  yield takeEvery(ADD_REPORT_ALERT, addReportAlert);
}

const addReportAlertAsync = async (report_alert) => {
  return await apiAuth
    .post("/api/report/schedule/", report_alert)
    .then((report_alert) => {
      return report_alert.data;
    })
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};
function* addReportAlert(report_alertObj) {
  try {
    const report_alert = yield call(
      addReportAlertAsync,
      report_alertObj.payload
    );

    if (!report_alert.message) {
      yield put({ type: ADD_REPORT_ALERT_SUCCESS, payload: report_alert });
    } else {
      report_alert.message.action = ADD_REPORT_ALERT_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: report_alert.message });
    }
  } catch (error) {
    yield put({ type: ADD_REPORT_ALERT_ERROR, payload: error });
  }
}

export function* watchEditReportAlert() {
  yield takeEvery(EDIT_REPORT_ALERT, editReportAlert);
}

const editReportAlertAsync = async (report_alert) => {
  return await apiAuth
    .patch(`/api/report/schedule/${report_alert.id}/`, report_alert)
    .then((report_alert) => report_alert.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};

function* editReportAlert(report_alertObj) {
  try {
    const report_alert = yield call(
      editReportAlertAsync,
      report_alertObj.payload
    );

    if (!report_alert.message) {
      yield put({ type: EDIT_REPORT_ALERT_SUCCESS, payload: report_alert });
    } else {
      report_alert.message.action = EDIT_REPORT_ALERT_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: report_alert.message });
    }
  } catch (error) {
    yield put({ type: EDIT_REPORT_ALERT_ERROR, payload: error });
  }
}

export function* watchDeleteReportAlert() {
  yield takeEvery(DELETE_REPORT_ALERT, deleteReportAlert);
}

const deleteReportAlertAsync = async (report_alert) =>
  await apiAuth
    .delete(`/api/employee/report_alert/${report_alert.id}/`)
    .then((report_alert) => report_alert)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* deleteReportAlert(report_alertObj) {
  try {
    const report_alert = yield call(
      deleteReportAlertAsync,
      report_alertObj.payload
    );

    if (!report_alert.message) {
      yield put({
        type: DELETE_REPORT_ALERT_SUCCESS,
        payload: report_alertObj.payload.id,
      });
    } else {
      report_alert.message.action = DELETE_REPORT_ALERT_ERROR;
      yield put({ type: FACILITY_ACTION_ERROR, payload: report_alert.message });
    }
  } catch (error) {
    yield put({ type: DELETE_REPORT_ALERT_ERROR, payload: error });
  }
}

export default function* rootSaga() {
  yield all([fork(watchActionError)]);
  yield all([fork(watchGetFacility)]);
  yield all([fork(watchAddFacility)]);
  yield all([fork(watchDeleteFacility)]);
  yield all([fork(watchEditFacility)]);
  yield all([fork(watchAddFloor)]);
  yield all([fork(watchEditFloor)]);
  yield all([fork(watchDeleteFloor)]);
  yield all([fork(watchAddSector)]);
  yield all([fork(watchDeleteSector)]);
  yield all([fork(watchEditSector)]);
  yield all([fork(watchAddShift)]);
  yield all([fork(watchDeleteShift)]);
  yield all([fork(watchEditShift)]);
  yield all([fork(watchAddEmployeePolicy)]);
  yield all([fork(watchDeleteEmployeePolicy)]);
  yield all([fork(watchEditEmployeePolicy)]);
  yield all([fork(watchAddHoliday)]);
  yield all([fork(watchDeleteHoliday)]);
  yield all([fork(watchEditHoliday)]);
  yield all([fork(watchAddReportAlert)]);
  yield all([fork(watchDeleteReportAlert)]);
  yield all([fork(watchEditReportAlert)]);
}
